import React from 'react';
import { Page } from '../Page';
export function PageCopyright() {
  return <Page hideFooter variant="light" data-id="element-1336" data-mp="uag0jqf5pbjz">
      <div className="flex flex-col h-full justify-end" data-id="element-1337" data-mp="ubhlqnpvzeff">
        <div className="space-y-8 max-w-md" data-id="element-1338" data-mp="gj1iblt2pedz">
          <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1339" data-mp="gkcizcr8260v">
            This guide is for informational and educational purposes only and
            does not constitute medical advice. It is not intended to diagnose,
            treat, cure, or prevent any disease or condition. Always consult
            your physician or qualified healthcare provider before making
            changes to your medication, nutrition, supplement regimen, or
            exercise program.
          </p>

          <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1340" data-mp="147kq8087np5j">
            © 2025 Jack Achenbach. All rights reserved. No part of this
            publication may be reproduced, distributed, or transmitted in any
            form or by any means, including photocopying, recording, or other
            electronic or mechanical methods, without the prior written
            permission of the author, except for brief quotations in reviews and
            certain noncommercial uses permitted by copyright law.
          </p>
        </div>
      </div>
    </Page>;
}